<template>
  <div class="s-setting-container">
    <div class="main-header">
      <div>
        Support Contact
      </div>
      <SaveCancelSection
        v-if="adminRole === 'admin'"
        :cancel="resetPartnerConfig"
        :save="updatePartnerConfig"
        :disabled="!changeCheck"
      />
    </div>
    <SupportContact
      :email="email"
      :phone="phone"
      :onChange="handleChange"
      :errorObj="errorObj"
    />
    <ProcessOverlay
      :show="updating"
      text="Saving"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SupportContact from '../../partnerSettings/SupportContact.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SaveCancelSection from '@shared/components/setting/shared/SaveCancelSection.vue';

import formatPhoneNumber from '../../../lib/formatter/formatPhoneNumber';
import emailValidation from '../../../lib/errorCatch/emailValidation';
import phoneValidation from '../../../lib/errorCatch/phoneValidation';

export default {
  name: 'SupportContactSection',
  components: {
    SaveCancelSection,
    ProcessOverlay,
    SupportContact,
  },
  mixins: [partnerSettingsMixin],
  props: {
    partnerSettings: Object,
    update: Function,
  },
  data() {
    const {
      SERVICE_REQUEST_SUPPORT_EMAIL = '',
      SERVICE_REQUEST_SUPPORT_PHONE = '',
    } = this.partnerSettings;
    return {
      email: SERVICE_REQUEST_SUPPORT_EMAIL,
      phone: SERVICE_REQUEST_SUPPORT_PHONE,
      errorObj: {},
      updating: false,
    };
  },
  computed: {
    changeCheck() {
      let changes = false
      const {
        SERVICE_REQUEST_SUPPORT_EMAIL = '',
        SERVICE_REQUEST_SUPPORT_PHONE = '',
      } = this.partnerSettings;
      const {
        email,
        phone,
      } = this;
      if (SERVICE_REQUEST_SUPPORT_EMAIL !== email) {
        changes = true;
      }
      if (SERVICE_REQUEST_SUPPORT_PHONE !== phone) {
        changes = true;
      }
      if (!changes) {
        this.changePartnerSettingsValue('showWarningOnExit', false);
      } else if (changes && !this.showWarningOnExit && !this.warningTab) {
        this.changePartnerSettingsValue('showWarningOnExit', true);
      }
      return changes;
    },
  },
  methods: {
    handleChange(field, value) {
      let v = value;
      if (field === 'phone') {
        v = formatPhoneNumber(v);
      }
      this[field] = v;
    },
    resetPartnerConfig() {
      const {
        SERVICE_REQUEST_SUPPORT_EMAIL = '',
        SERVICE_REQUEST_SUPPORT_PHONE = '',
      } = this.partnerSettings;
      this.email = SERVICE_REQUEST_SUPPORT_EMAIL;
      this.phone = SERVICE_REQUEST_SUPPORT_PHONE;
      this.errorObj = {};
      this.updating = false;
    },
    async updatePartnerConfig() {
      const {
        email,
        phone,
      } = this;
      const errorObj = {};
      this.changePartnerSettingsValue('showWarningOnExit', false);
      if (email && !emailValidation(email)) {
        errorObj.emailErr = 'Email is not valid';
      }
      if (phone && !phoneValidation(phone)) {
        errorObj.phoneErr = 'Phone number is not valid';
      }
      this.errorObj = errorObj;
      if (Object.keys(errorObj).length === 0) {
        this.updating = true;
        await this.update({
          SERVICE_REQUEST_SUPPORT_EMAIL: email,
          SERVICE_REQUEST_SUPPORT_PHONE: phone,
        });
        this.updating = false;
      }
    },
  },
};
</script>
